// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".round{border-radius:50%}.avatar-circle{text-align:center;border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%}.initials{position:relative;top:7px;font-size:15px;line-height:15px;color:#fff}", ""]);
// Exports
module.exports = exports;
